import ListWMDSResult from '../wmds.result.List.i18n';
import ListWSFinderResult from '../wsfinder.result.List.i18n';

export default {
  components: { ListWMDSResult, ListWSFinderResult },
  data: () => ({ base: true, list_wsfinder_result : false, lsit_wmds_result : false, sync : { th : undefined, interval : 15, stop : false } }),
  methods: {
    refresh() {
      if(this.sync.th) { this.sync.th = undefined; }
      if(!this.sync.stop && this.$refs._list_wsfinder_result) { this.$refs._list_wsfinder_result.refresh(); }
      if(!this.sync.stop && this.$refs._list_wmds_result) { this.$refs._list_wmds_result.refresh(); }
      this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval );
      console.log("integrity", 'status', this.sync.stop ? 'stop' : 'refresh');
      // interval 30 sec
    },
    select({ id, tag }) {
      this.list_wsfinder_result = this.lsit_wmds_result = true;
      if(!this.sync.th) { this.refresh() }
    },
    SyncClear() {
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; console.debug("integtiry", "sync", "clear") }
    },
    pause: function() { this.sync.stop = !this.sync.stop; this.refresh(); },
  },
  watch: {
    '$route' (to, from) {
      console.log('integrity.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created() { console.log('integrity.vue', 'created'); },
  destroyed() { console.log('integrity.vue', 'destroyed'); this.SyncClear() },
  mounted() { console.log('integrity.vue', 'mounted'); this.select(this.$route.params); },
}